import { css } from '@eti/styles';
import Wall from './Wall';
import Wing from './Wing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: fit-content;

  html[dir='rtl'] & {
    flex-direction: row-reverse;
  }
`;
const Row = _ref => {
  let {
    children,
    isEmptyRow,
    isOverWing
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    children: [isOverWing && /*#__PURE__*/_jsx(Wing, {
      isEmptyRow: isEmptyRow,
      isLeft: true
    }), /*#__PURE__*/_jsx(Wall, {
      "data-testid": "leftWall",
      isEmptyRow: isEmptyRow,
      isLeft: true,
      isOverWing: isOverWing
    }), children, /*#__PURE__*/_jsx(Wall, {
      "data-testid": "rightWall",
      isEmptyRow: isEmptyRow,
      isOverWing: isOverWing,
      isRight: true
    }), isOverWing && /*#__PURE__*/_jsx(Wing, {
      isEmptyRow: isEmptyRow,
      isRight: true
    })]
  });
};
export default Row;
//# sourceMappingURL=Row.js.map